export function isNewChatCommand(prompt: string): boolean {
  return /^\/new(?:\s+chat)?$/i.test(prompt.trim());
}
